<template>
  <v-card elevation="3" class="rounded-xl">
    <v-row class="my-0">
      <v-col cols="12">
        <v-card-title v-if="percentDif > 0 && chartValues.length > 0">
          ER Cost
          <v-icon class="mdi mdi-arrow-down success--text mb-1" size="15"></v-icon>
          <span class="success--text">{{ percentDif }}%</span>
        </v-card-title>
        <v-card-title v-if="percentDif < 0 && chartValues.length > 0">
          ER Cost
          <v-icon class="mdi mdi-arrow-up error--text mb-1" size="15"></v-icon>
          <span class="error--text">{{ Math.abs(percentDif) }}%</span>
        </v-card-title>
        <v-card-title v-if="percentDif === 0 && chartValues.length > 0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                ER Cost
                <v-icon class="mdi mdi-swap-vertical mb-1" size="15"></v-icon> -
              </span>
            </template>
            <span>Less than 1% change</span>
          </v-tooltip>
        </v-card-title>
        <v-alert type="info" v-if="chartValues.length === 0">No Data for selected input</v-alert>
        <v-card-title v-if="chartValues.length < 1">
          ER Cost
          <v-divider class="my-2"></v-divider>
        </v-card-title>
      </v-col>
      <v-col v-if="view === 'dashboard top'" class="pt-0 text-right" cols="12" lg="6">
        <v-btn-toggle v-model="dashboardRange" class="pa-2" color="secondary" group exclusive>
          <v-btn small class="pa-4"> 3 Months </v-btn>

          <v-btn small class="pa-4"> 6 Months </v-btn>

          <v-btn small class="pa-4"> 12 Months </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <line-chart
      :data="dataCollection"
      :options="options"
      :styles="chartStyles"
      :chart="'er costs'"
    />
  </v-card>
</template>

<script>
import LineChart from '../charts/LineChart';

export default {
  components: {
    LineChart,
  },
  props: ['chartInfo', 'view'],
  data() {
    return {
      dataCollection: null,
      dashboardRange: null,
      percentDif: 0,
      chartMonths: [],
      chartValues: [],
      lineColor: '#90BE6D',
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let value = data.datasets[0].data[tooltipItem.index];
              if (parseInt(value) >= 1000) {
                return `$${value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
              }
              return `$${value}`;
            },
          },
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: 'Months',
              },
              gridLines: {
                color: 'rgba(61, 97, 133, 0.25)',
                display: true,
                drawBorder: false,
                drawTicks: false,
              },
              ticks: {
                padding: 10,
              },
            },
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'ER Costs ($)',
              },
              gridLines: {
                display: false,
              },
              ticks: {
                callback(value, index, values) {
                  if (parseInt(value) >= 1000) {
                    return `$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
                  }
                  return `$${value}`;
                },
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.chartMonths = [];
      this.chartValues = [];

      this.chartInfo.forEach((info) => {
        this.chartMonths.push(info.month);
        this.chartValues.push(info['er visits cost']);
      });
      this.getPercentDif();
    },
    async getPercentDif() {
      // check for undefined values
      const firstVal = this.chartValues[0] ? this.chartValues[0] : 0;
      const lastVal = this.chartValues[this.chartValues.length - 1]
        ? this.chartValues[this.chartValues.length - 1]
        : 0;

      const decreaseValue = firstVal - lastVal;
      this.percentDif =
        firstVal !== 0
          ? Math.ceil((decreaseValue / firstVal) * 100)
          : Math.ceil(decreaseValue * 100);

      this.loading = false;
    },
    chartData() {
      this.dataCollection = {
        labels: this.chartMonths,
        datasets: [
          {
            label: 'ER Visits Cost',
            borderColor: this.lineColor,
            pointBackgroundColor: this.lineColor,
            borderWidth: 3,
            data: this.chartValues,
          },
        ],
      };
      this.dataCollection;
    },
  },
  computed: {
    chartStyles() {
      if (this.view === 'report') {
        return {
          height: '25vh',
        };
      }
    },
  },
  watch: {
    async chartInfo() {
      this.getData();
    },
    async chartValues() {
      this.chartData();
    },
    async dashboardRange() {
      this.$emit('dashboardRange', this.dashboardRange);
    },
  },
};
</script>
